import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CanActivate} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {AppSettings} from '../app-settings';


@Injectable()
export class AuthGuard implements CanActivate {

 constructor(private auth: AuthenticationService, private router: Router) {
 }

 canActivate(){
  if(this.auth.loggedIn()) {
   return true;
  }
  else {
   this.router.navigate(['/home']);
   return false;
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/auth/auth-guard.service.ts